// SAMPLE daily "bulk" menu — the items cooked in bulk twice a day and updated
// daily by staff. These are placeholders to demo the sold-out / low-stock / batch
// behaviour; the client replaces them each day from the admin panel.
import type { DailyItem } from "../lib/types";
import { DAILY_IMAGES } from "./images";

type DRow = [
  name: string,
  nameAr: string,
  price: number,
  initialQty: number,
  remainingQty: number,
  fast: boolean,
  slug: string,
];

const ROWS: DRow[] = [
  ["Chicken Biryani (Tray)", "برياني دجاج (صينية)", 1.5, 40, 22, true, "chicken-biryani"],
  ["Mutton Biryani (Tray)", "برياني لحم غنم (صينية)", 2.25, 30, 9, true, "mutton-biryani"],
  ["Chicken Karahi (Full)", "كراهي دجاج (كامل)", 3.5, 20, 3, false, "chicken-karahi"], // low stock, made fresh
  ["Beef Nihari", "نيهاري لحم", 2.0, 25, 25, true, "beef-nihari"],
  ["Chicken Haleem", "هريس دجاج", 1.75, 30, 0, true, "chicken-haleem"], // sold out
  ["Aloo Gosht", "بطاطا باللحم", 1.9, 20, 14, true, "aloo-gosht"],
  ["Butter Chicken", "دجاج بالزبدة", 2.5, 24, 16, false, "butter-chicken"],
  ["Chana Chaat (Box)", "تشانا تشاات (علبة)", 0.75, 50, 41, true, "chana-chaat"],
];

/** Build a fresh daily-menu array for a given date (defaults to a morning batch). */
export function sampleDailyItems(
  batchId = "morning-1",
  session: "morning" | "evening" = "morning",
): DailyItem[] {
  return ROWS.map((row, i) => {
    const [name, nameAr, price, initialQty, remainingQty, fast, slug] = row;
    return {
      id: `daily-${i}`,
      name,
      nameAr,
      category: "daily",
      session,
      batchId,
      price,
      initialQty,
      remainingQty,
      soldOut: remainingQty <= 0,
      active: true,
      fastDelivery: fast,
      imageURL: DAILY_IMAGES[slug],
      updatedAt: 0,
    };
  });
}

export const DAILY_SAMPLE: DailyItem[] = sampleDailyItems();
